import BaseModel from '@/api/RestModels/baseModel';
import api from '@/api/RestModels/client';

class DeviceInfoRestModel extends BaseModel {
  path = 'deviceInfos/candidate';

  // we dont get anything back from this request, just ignore the response basicly unless its an error but that should have been handled in the client
  get = async () => api.get(this.path);
}

export default new DeviceInfoRestModel();
